import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-column',
  template: `
    <div class="modal-column">
      <div *ngFor="let item of data">
        <div class="img">
          <img [src]="item.img | sanitizeUrl" />
        </div>
        <h3 class="modal-column__title">{{ item.title }}</h3>
        <div *ngIf="item.description" [innerHTML]="item.description | sanitizeHtml"></div>
        <div *ngIf="item.externalLinks[0]">
          <p *ngFor="let link of item.externalLinks">
            <a [href]="link.url" target="blank" [innerHTML]="link.title | sanitizeHtml"></a>
          </p>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./column.component.scss']
})
export class ColumnComponent {
  @Input() data: any;

  public openLink(url) {
    window.open(url, '_blank');
  }
}
